export default __webpack_public_path__ + "static/media/component003-right.920ea9ae.png";